import { render, staticRenderFns } from "./About_D.vue?vue&type=template&id=a67b3d28&scoped=true"
import script from "./About_D.vue?vue&type=script&lang=js"
export * from "./About_D.vue?vue&type=script&lang=js"
import style0 from "./About_D.vue?vue&type=style&index=0&id=a67b3d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b3d28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
